<template>
    <section class=" font-poppins">
            <div class="mt-4 bg-gray-100 pl-10 pr-10 pb-10">
                <div class="flex justify-between pt-5 md:flex-col">
                    <p class="text-blue-600 pl-3 font-semibold pt-2">Income Percentage</p>
                    <div class="border bg-white p-3 mr-4 ml-6 md:w-full md:ml-0">
                        <p class="text-blue-600 text-xl font-semibold">NGN {{packageIncome.totalCost}}</p>
                        <p class="text-sm text-center">Total Income</p>
                    </div>
                </div>
                <pie-chart  :data="
                    [
                        ['Send a Package', packageIncome.sendAPackageTotalCost],
                        ['Buy for me', packageIncome.buyForMeTotalCost],
                        ['Ride', packageIncome.bookARideTotalCost],
                        ['Haulage', packageIncome.haulageTotalCost]
                    ]">
                </pie-chart>
            </div>
    </section>
</template>

<script>
import axios from 'axios';
import {baseUrl} from '../../../Config';
const url = baseUrl;
export default {
    data() {
        return {
            totalMonthlyHaulage : "",
            totalMonthlyPackage : "",
            totalMonthlyBuyForMe : "",
            totalMonthlyRide: "",
            token: localStorage.getItem("token"),
            packageIncome: []
        }
    },

    mounted() {
        this.getMonthlyTotalHaulage();  
        this.getMonthlyTotalPackage(); 
        this.getMonthlyBuyForMe();  
        this.getPackageIncome();  
        this.getMonthlyTotalRide();
    },

    methods: {
         goBack() {
            this.$router.go(-1)
        },

        getMonthlyTotalPackage() {
            axios({
                method: 'GET',
                url: `${url}/v1/web/dashboard/orders?orderType=package&timeFrame=monthly`,
                headers: {
                    'Content-type': 'application/json',
                    authorization: `Bearer ${this.token}`,
                    'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                },
            })
            .then((response) => {
                let total = response.data.data
                this.totalMonthlyPackage = total.total
                this.statsMonthlyPackage = total.stats
            })
            .catch((error) => {
                console.log(error)
            })
        },

        getMonthlyTotalHaulage() {
            axios({
                method: 'GET',
                url: `${url}/v1/web/dashboard/orders?orderType=haulage&timeFrame=monthly`,
                headers: {
                    'Content-type': 'application/json',
                    authorization: `Bearer ${this.token}`,
                    'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                },
            })
            .then((response) => {
                let total = response.data.data
                this.totalMonthlyHaulage = total.total
                this.statsMonthlyHaulage = total.stats
            })
            .catch((error) => {
                console.log(error)
            })
        },

        getMonthlyBuyForMe() {
            axios({
                method: 'GET',
                url: `${url}/v1/web/dashboard/orders?orderType=buyForMe&timeFrame=monthly`,
                headers: {
                    'Content-type': 'application/json',
                    authorization: `Bearer ${this.token}`,
                    'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                },
            })
            .then((response) => {
                let total = response.data.data
                this.totalMonthlyBuyForMe = total.total
                this.statsMonthlyBuyForMe = total.stats
            })
            .catch((error) => {
                console.log(error)
            })
        },

        getMonthlyTotalRide() {
            axios({
                method: 'GET',
                url: `${url}/v1/web/dashboard/orders?orderType=bookARide&timeFrame=monthly`,
                headers: {
                    'Content-type': 'application/json',
                    authorization: `Bearer ${this.token}`,
                    'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                },
            })
            .then((response) => {
                let total = response.data.data
                this.totalMonthlyRide = total.total
                this.statsMonthlyRide = total.stats
            })
            .catch((error) => {
                console.log(error)
            })
        },
        getPackageIncome() {
            let id = localStorage.getItem("userId")
            axios({
                method: 'GET',
                url: `${url}/v1/web/dashboard/income/${id}`,
                headers: {
                    'Content-type': 'application/json',
                    authorization: `Bearer ${this.token}`,
                    'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                },
            })
            .then((response) => {
                this.packageIncome = response.data.data
            })
            .catch((error) => {
                console.log(error)
            })
        },

    }
}
</script>